
import { defineComponent, onMounted,onBeforeMount,ref,computed } from "vue";
import KTChartWidget1 from "@/components/widgets/charts/Widget1.vue";
import KTListWidget5 from "@/components/widgets/lists/Widget5.vue";
import KTTableWidget5 from "@/components/widgets/tables/Integrations.vue";
import KTListWidget1 from "@/components/widgets/lists/Widget1.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import { useStore } from "vuex";
import { Actions } from "@/store/enums/StoreEnums";
import { useToast } from "vue-toastification";
import { Integration } from "@/dtos/Integration";
import { LogDTO } from "@/dtos/LogDTO";
const toast = useToast();


export default defineComponent({
  name: "account-overview",
  components: {
    KTChartWidget1,
    KTListWidget5,
    KTTableWidget5,
    KTListWidget1,
  },
  setup() {
    const store = useStore();
    const Integrations = ref(null);
    const Logs = ref(null);
    const refreshData=  async ()=>{
      await store.dispatch(Actions.GETINTEGRATIONS).then((response: Integration[]) => {
        Integrations.value = response as any ;
      });
    }
    // Firma Bilgileri — pulled from integrations into ProfileDetails (backend).
    const profileDetails = computed(() => store.getters.getProfileDetails);
    const infoRows = computed(() => {
      const p: any = profileDetails.value || {};
      return [
        { label: "Şube / İşletme", value: p.branchName },
        { label: "Firma Ünvanı", value: p.companyName },
        { label: "Yetkili", value: p.nameSurname },
        { label: "Telefon", value: p.phoneNumber },
        { label: "E-posta", value: p.email },
        { label: "Adres", value: p.address },
        {
          label: "Şehir / İlçe",
          value: [p.city, p.district].filter(Boolean).join(" / "),
        },
        { label: "Vergi No", value: p.taxNumber },
        { label: "Vergi Dairesi", value: p.taxOffice },
        { label: "IBAN", value: p.iban },
      ];
    });
    const hasAnyInfo = computed(() => infoRows.value.some((r) => r.value));

    const logLimit = ref(50);
    const hasMoreLogs = ref(false);
    const refreshLogs = async () => {
      const response: any = await store.dispatch(Actions.GETLOGS, { skip: 0, limit: logLimit.value });
      Logs.value = response;
      hasMoreLogs.value = Array.isArray(response) && response.length >= logLimit.value;
    };
    const loadMoreLogs = async () => {
      logLimit.value += 50;
      await refreshLogs();
    };

    onMounted(() => {
      setCurrentPageBreadcrumbs("Genel", ["Hesap Bilgileri"]);
    });
    onBeforeMount(async () => {
       refreshData();
       refreshLogs();
       store.dispatch(Actions.FETCH_PROFILEDETAILS);
    });
    return {
      Integrations,
      Logs,
      refreshData,
      refreshLogs,
      hasMoreLogs,
      loadMoreLogs,
      profileDetails,
      infoRows,
      hasAnyInfo
    };
  },
});
